// ReviewResult.tsx
import { ReviewResult as ReviewResultType } from '../types';
import RiskCard from './RiskCard';

export default function ReviewResult({ result }: { result: ReviewResultType }) {
  const total = result.risks.length;

  return (
    <div className="max-w-3xl mx-auto p-8">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold">审查结果</h2>
        <button
          onClick={() => window.location.reload()}
          className="text-sm text-blue-600 hover:underline"
        >
          审查新合同
        </button>
      </div>

      {/* Summary */}
      <div className="bg-white rounded-xl shadow-sm border p-6 mb-6">
        <div className="flex items-center gap-4 mb-4">
          <div className="flex gap-2">
            <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-sm font-medium">
              🔴 {result.risk_counts.high || 0} 高风险
            </span>
            <span className="px-3 py-1 bg-yellow-100 text-yellow-700 rounded-full text-sm font-medium">
              🟡 {result.risk_counts.medium || 0} 中风险
            </span>
            <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm font-medium">
              🟢 {result.risk_counts.low || 0} 低风险
            </span>
          </div>
        </div>
        <p className="text-gray-600">{result.summary}</p>
      </div>

      {/* Contract info */}
      <div className="bg-gray-50 rounded-lg p-4 mb-6 text-sm text-gray-600">
        <span className="font-medium">合同类型：</span>
        {result.contract_info.contract_type || '未识别'}
        {result.contract_info.parties.length > 0 && (
          <>
            <span className="ml-4 font-medium">签约方：</span>
            {result.contract_info.parties.join('、')}
          </>
        )}
        {result.contract_info.amount && (
          <>
            <span className="ml-4 font-medium">金额：</span>
            {result.contract_info.amount}
          </>
        )}
      </div>

      {/* Risk list */}
      <div>
        <h3 className="text-lg font-medium mb-4">风险详情（共 {total} 条）</h3>
        {result.risks.map((risk, i) => (
          <RiskCard key={i} risk={risk} index={i} />
        ))}
      </div>
    </div>
  );
}